import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { App } from 'ionic-angular';

import { InfoPage } from '../info/info';
import { MainPage } from '../main/main';
import { UrListPage } from '../ur-list/ur-list';

import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-ur-add',
  templateUrl: 'ur-add.html',
})
export class UrAddPage {

  form: FormGroup;
  whoom: string;
  sended: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formbuilder: FormBuilder,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http,
    public app: App
  )
  {
    this.whoom = 'med';
    this.sended = false;

    if (navParams.get('from_menu') == '2') this.whoom = 'med';
    if (navParams.get('from_menu') == '3') this.whoom = 'ur';

    this.form = new FormGroup({
      text: new FormControl('', [Validators.required, Validators.minLength(5)])
    })
  }

  sendData() {
    console.log(this.form.value);
    console.log(this.form.value['text']);

    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });

    let form_info: any;
    let postData = new FormData();

    form_info = this.form.value;
    
    for (var key in form_info) {
      postData.append(key, form_info[key]);
    }

    loadingPopup.present();
    this.http.post(this.params.apiURL + '?act=' + this.whoom+'-add&id_user=' + this.params.id_user, postData)
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          setTimeout(() => {
            console.log(data);

            loadingPopup.dismiss();
            this.sended = true;
            //this.app.getRootNav().setRoot(UrListPage, {index: '1' });
          }, 1000);

        },

        err => {
          loadingPopup.dismiss();
        }

      );

  }

  SegmentClick() {
    this.sended = false;
  }

  backToMain() {
    this.navCtrl.setRoot(MainPage);
  }  

  openQs() {
    this.navCtrl.push(UrListPage);
  }

  openInfoPage() {
    this.navCtrl.setRoot(InfoPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UrAddPage');
  }

  ionViewWillEnter() {
    this.params.stat('add-quest');    
  }   

}



// WEBPACK FOOTER //
// ./src/pages/ur-add/ur-add.ts